export class SessionHostIdCount {
  public instanceId: number;
  public count: number;
  constructor(data ? : any) {
    this.instanceId = data && data.instanceId ? data.instanceId : 0;
    this.count = data && data.count ? data.count : 0;
  }
}
